import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Trucker } from "../models/Trucker";
import { TruckerItem } from "../models/TruckerItem";
import { TruckerSearchParameters } from '../models/TruckerSearchParameters';

@Injectable({
    providedIn: 'root'
})
export class TruckerData {
    constructor(private http: HttpClient) {

    }
    
  private messageSource = new BehaviorSubject("default message");
  currentMessage = this.messageSource.asObservable();
  sendEmailsData(message: any) {
    this.messageSource.next(message)
  }
  private returnMessageSource = new BehaviorSubject("retrun message");
  returnCurrentMessage = this.returnMessageSource.asObservable();
  returnSendEmailsData(message: any) {
    this.returnMessageSource.next(message)
  }

    searchTruckers(searchParams: TruckerSearchParameters): Observable<TruckerItem[]> {
        return this.http.post<TruckerItem[]>('api/trucker/searchtruckers', searchParams);
    }

    getTruckerById(customerId: number): Observable<Trucker> {
        return this.http.get<Trucker>('api/trucker/gettruckerbyid/' + customerId);
    }

    saveTrucker(trucker: Trucker): Observable<boolean> {
        return this.http.post<boolean>('api/trucker/savetrucker/', trucker);
    }
}